// libraries.
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

// slices.
import { apiBudgetRoute } from "../apiSlices";

// interfaces.
import { ModelError } from "../interfaces/interfaces";
import {
  UpdateMetadataBody,
  UpdateMetadataResponse,
} from "./interfaces/rawRules.interfaces";

export const metadataEndpoints = apiBudgetRoute.injectEndpoints({
  endpoints: (builder) => ({
    updateRuleMetadata: builder.mutation<UpdateMetadataResponse, UpdateMetadataBody>({
      query: (body) => ({
        url: "/rules/metadata",
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_result, _error, { schema }) => [
        { type: "Rules", id: schema },
      ],
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: "updateRuleMetadata",
        };
        return modelError;
      },
    }),
  }),
});

export const { useUpdateRuleMetadataMutation } = metadataEndpoints;
